import SearchableDropdownSelect from 'shared/components/searchable_dropdown_select/SearchableDropdownSelect';

export default SearchableDropdownSelect;
